<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('finance') }}
    </h1>
    <div class="main__body">
      <div class="form-body">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">№</th>
            <th scope="col">{{ $t('date') }}</th>
            <th scope="col">{{ $t('type') }}</th>
            <th scope="col">{{ $t('function') }}</th>
            <th scope="col">{{ $t('status') }}</th>
            <th scope="col">{{ $t('amount') }}</th>
            <th scope="col">{{ $t('payment-method') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in payments" v-bind:key="item.id">
            <th scope="row">{{ index + 1}}</th>

            <td>{{ item.date_create }}</td>

            <td v-if="item.type == 1">
              <img src="@/assets/social/telegram.svg">
            </td>

            <td v-else-if="item.type == 2">
              <img src="@/assets/social/viber.svg">
            </td>

            <td v-else-if="item.type == 3">
              <img src="@/assets/social/sms.svg">
            </td>

            <td v-else-if="item.type == 4">
              <img src="@/assets/social/email.svg">
            </td>

            <td v-else-if="item.type == 5">
              <img src="@/assets/social/facebook.svg">
            </td>

            <td v-else-if="item.type == 6">
              <img src="@/assets/social/vk.svg">
            </td>

            <td v-else>-</td>

            <td v-if="item.function">
              {{ item.function }}
            </td>

            <td v-else>-</td>

            <td v-if="item.status == 1">{{ $t('completed') }}</td> <td v-else>{{ item.status }}</td>

            <td>{{ item.sum }}&#8381;</td>

            <td class="text-green" v-if="!item.type || !item.function">{{ $t('depositing') }}</td> <td class="text-danger" v-else>{{ $t('debt') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<style scoped>
.text-green{
  color: green;
}
</style>

<script>
import axios from 'axios'
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'history-pay',
  data: function(){
    return{
      payments: [],
      isLoading: false,
      fullPage: true
    }
  },
  created: function(){
    this.getPayments();
  },
  methods: {
    getPayments: function(){
      this.isLoading = true;
      axios.post('getPayments').then(response => {
        var status = response.data.status;
        if(status){
          this.payments = response.data.history;
          this.isLoading = false;
        }
      });
    },
  },
  components: {
    loading
  }
}
</script>